class LL_Dialog extends HTMLElement {
  constructor() {
    super();
    this.dialogElement = this.querySelector('.js_dialog');
    this.toggleButtons = this.querySelectorAll('.js_dialogToggle');
    this.videoElement = this.dialogElement.querySelector('video');

    this.dialogElement.addEventListener('click', event => {
      if (event.target === this.dialogElement) {
        this.toggleDialog();
      }
    });

    this.toggleButtons.forEach(button => {
      button.addEventListener('click', this.toggleDialog.bind(this));
    });
  }

  /**
   * Toggle dialog visibility based on its current state
   */
  toggleDialog() {
    if (this.isDialogOpen()) {
      this.closeDialog();
    } else {
      this.openDialog();
    }
  }

  /**
   * Check if the dialog is currently open
   * @returns {Boolean} True if the dialog is open
   */
  isDialogOpen() {
    return this.dialogElement.hasAttribute('open');
  }


  /**
   * Open the dialog and add necessary event listeners
   */
  openDialog() {
    if (typeof this.dialogElement.showModal === "function") {
      this.dialogElement.showModal();
      if (this.videoElement) {
        this.videoElement.play();
      }
    } else {
      console.error('The <dialog> API is not supported by this browser');
    }
  }

    /**
   * Close the dialog and remove event listeners
   */
  closeDialog() {
    if (this.videoElement) {
      this.videoElement.pause();
      this.videoElement.currentTime = 0; // Reset the video to the start
    }
    this.dialogElement.close();
  }
}

customElements.define('ll-dialog', LL_Dialog);

{
  const checkbox = document.getElementById('js_gift');
  const app = document.querySelector('#main .shopify-section--apps');
  if (checkbox) {
    checkbox.addEventListener('change', function() {
      if (checkbox.checked) {
        app.classList.add('hidden');
        const closeBtn = document.querySelector('.delivery-select-container--close');
        if (closeBtn) {
          const event = new Event('click');
          closeBtn.dispatchEvent(event);
        }

        const select = document.querySelector('select.delivery-select-container__select');
        if (select) {
          setTimeout(() => {
            select.value = '指定なし';
          }, 1000);
        }
      } else {
        app.classList.remove('hidden');
      }
    }, false);
  }
}

{
  document.addEventListener('DOMContentLoaded', initializeVideoSlider);
  function initializeVideoSlider(){
    if (document.getElementById('js-videoSlider')) {
      new Swiper("#js-videoSlider", {
        slidesPerView: 2,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
        },
      });
    }
  }
}

// {
//   const giftModal = document.getElementById('js_giftModal');
//   const toggles = document.querySelectorAll('js_giftToggle');
//   toggles.forEach(toggle => {
//     toggle.addEventListener('click', function() {
//       giftModal.setAttribute('aria-hidden', !giftModal.getAttribute('aria-hidden'))
//     }, false);
//   });
// }